import { useEffect, useState } from 'react'

type TimeLeft = {
  hours: string
  minutes: string
  seconds: string
}

const START_SECONDS = 23 * 3600 + 27 * 60 + 35

const pad = (value: number): string => value.toString().padStart(2, '0')

export function useCountdown(): TimeLeft {
  const [remaining, setRemaining] = useState<number>(START_SECONDS)

  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? START_SECONDS : prev - 1))
    }, 1000)
    return () => window.clearInterval(interval)
  }, [])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
